export default "__VITE_ASSET__lbdIJ0Rs__"